import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getCurrentOrderInvoiceThunk, getInvoiceThunk } from '../../../../../../redux/thunk/invoice'
import { setShowInvoiceOptionsModal } from '../../../../../../redux/action/invoice'

export const useOpenOrderInvoice = (closeOrder) => {
	const dispatch = useDispatch()

	const openOrderInvoice = useCallback(async (order) => {
		const invoice = await dispatch(getCurrentOrderInvoiceThunk(order.orderId))
		if (!invoice) return
		closeOrder()
		await dispatch(getInvoiceThunk(invoice.id))
		dispatch(setShowInvoiceOptionsModal(true))
	}, [dispatch, closeOrder])

	return { openOrderInvoice }
}
